import {
  getTokensByNetwork,
  NETWORKS,
  TokenLogoMap,
  NetworkLogoMap,
  upperCaseNetworkType,
  getTokenHumanReadableNameByChain,
} from 'features/bill/lib';

import { Form, Select } from 'antd';

export const NetworkLabel = ({ network }) => {
  return (
    <div className="flex items-center">
      <div className="mr-2 h-4 w-4">
        <img
          src={NetworkLogoMap[upperCaseNetworkType(network)]}
          alt=""
          aria-hidden="true"
        />
      </div>
      <span>{upperCaseNetworkType(network)}</span>
    </div>
  );
};

export const TokenLabel = ({ token, tokenLabel }) => {
  return (
    <div className="flex items-center">
      <div className="mr-2 h-4 w-4">
        <img src={TokenLogoMap[token]} alt="" aria-hidden="true" />
      </div>
      <span>{tokenLabel}</span>
    </div>
  );
};

export const CryptoNetworkTokenSelect = ({
  network,
  allowedNetworks,
  token,
  allowedTokens,
  onNetworkChange,
  onTokenChange,
}) => {
  const _getNetworkList = () => {
    let res = NETWORKS;

    if (allowedNetworks) {
      res = res.filter((n) => allowedNetworks.includes(n));
    }

    return res;
  };

  const _getTokenList = (nVal) => {
    let res = getTokensByNetwork(nVal);

    if (allowedTokens) {
      res = res.filter((t) => allowedTokens.includes(t));
    }

    return res;
  };

  return (
    <div className="flex gap-4 flex-row">
      <div className="flex-1">
        <Form.Item layout="vertical" label="Network">
          <Select
            size="large"
            id="network"
            name="network"
            placeholder={'Select Network'}
            onChange={(val) => {
              onNetworkChange(val, _getTokenList(val)[0]);
            }}
            value={network}
            options={_getNetworkList().map((network) => ({
              value: network,
              label: <NetworkLabel network={network} />,
            }))}
          />
        </Form.Item>
      </div>

      <div className="flex-1">
        <Form.Item layout="vertical" label="Token">
          <Select
            size="large"
            id="token"
            name="token"
            placeholder={'Select Token'}
            onChange={(val) => {
              onTokenChange(val);
            }}
            value={token}
            options={_getTokenList(network).map((token) => ({
              value: token,
              label: (
                <TokenLabel
                  tokenLabel={getTokenHumanReadableNameByChain(token, network)}
                  token={token}
                />
              ),
            }))}
          />
        </Form.Item>
      </div>
    </div>
  );
};
